import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoimagePipe } from './pipes/noimage.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [NoimagePipe, SanitizeHtmlPipe],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [NoimagePipe, SanitizeHtmlPipe]
})
export class SharedModule {}
